import { useCreateRange, useUpdateRange } from './use-pricing-range-mutations';
import type { PricingRange } from '@/hooks/use-pricing-ranges';
import type { RangeFormState } from '../components/range-form-fields';

export type RangeFormMode =
  | { kind: 'create' }
  | { kind: 'edit'; range: PricingRange };

type SubmitResult = { submit: () => void; isPending: boolean };

function buildCreateArgs(state: RangeFormState) {
  return {
    range_min: Number(state.rangeMin),
    range_label: state.rangeLabel,
    tiers: state.tiers,
  };
}

export function useRangeSubmit(
  mode: RangeFormMode | null,
  state: RangeFormState,
  onClose: () => void
): SubmitResult {
  const create = useCreateRange();
  const update = useUpdateRange();
  const submit = (): void => {
    if (!mode) return;
    const opts = { onSuccess: onClose };
    if (mode.kind === 'edit') {
      update.mutate(
        {
          rangeId: mode.range.id,
          tiers: state.tiers,
          range_label: state.rangeLabel,
        },
        opts
      );
      return;
    }
    create.mutate(buildCreateArgs(state), opts);
  };
  return { submit, isPending: create.isPending || update.isPending };
}
